<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-to-right`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M43 4a1 1 0 011 1v38a1 1 0 01-1 1h-2a1 1 0 01-1-1V5a1 1 0 011-1h2zM26.4 14.618a1.4 1.4 0 01.904.332l9.433 7.981a1.4 1.4 0 010 2.138l-9.433 7.981A1.4 1.4 0 0125 31.982L24.999 26H5a1 1 0 01-1-1v-2a1 1 0 011-1h20v-5.982a1.4 1.4 0 011.4-1.4z"/></svg>
</template>
<script>

export default {
  name: 'IconToRight',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
